import React from "react";
import { FaUtensils } from "react-icons/fa";

interface FallBackImageProps {
  name?: string;
  containerStyle?: React.CSSProperties;
}

const FallBackImage: React.FC<FallBackImageProps> = ({ name, containerStyle }) => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // Professional apps use neutral, soft gradients for placeholders
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e7eb 100%)",
        position: "relative",
        overflow: "hidden",
        ...containerStyle,
      }}
    >
      {/* Decorative background element to add "texture" */}
      <div
        style={{
          position: "absolute",
          width: "150%",
          height: "150%",
          background: "radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%)",
          top: "-25%",
          left: "-25%",
          opacity: 0.5,
        }}
      />

      <div style={{ 
        position: "relative", 
        zIndex: 1, 
        textAlign: "center", 
        padding: '8px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
      }}>
        <FaUtensils
          style={{
            color: "#b0b8c1",
            fontSize: "clamp(20px, 4vw, 28px)",
            marginBottom: name ? "6px" : "0",
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.05))",
            flexShrink: 0,
          }}
        />
        
        {name && (
          <span
            style={{
              display: "block",
              fontSize: "10px",
              fontWeight: 600,
              color: "#868e96",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontFamily: "'Inter', sans-serif",
              maxWidth: "100%",
              width: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              padding: "0 4px",
              boxSizing: 'border-box',
              lineHeight: 1.2,
            }}
            title={name}
          >
            {name.length > 12 ? name.substring(0, 10) + '...' : name}
          </span>
        )}
      </div>
    </div>
  );
};

export default FallBackImage;